import {
  EditorState,
  convertFromRaw,
  convertFromHTML,
  ContentState,
} from 'draft-js';

const convert = (rawJsonFormat: string) => {
  let editorState;
  try {
    if (!rawJsonFormat) {
      editorState = EditorState.createEmpty();
    } else {
      const rawState = convertFromRaw(JSON.parse(rawJsonFormat));
      editorState = EditorState.createWithContent(rawState);
    }
  } catch {
    // Old inputs have a plain text format. Attempt to convert this to rich text
    const fallback = convertFromHTML(`<p>${rawJsonFormat}</p>`);
    const state = ContentState.createFromBlockArray(
      fallback.contentBlocks,
      fallback.entityMap
    );

    editorState = EditorState.createWithContent(state);
  }
  return editorState;
};

export default convert;
